import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import JwtService from '@/common/jwt.service'
import saveAs from 'file-saver'

import {
  API_URL
} from '@/common/config'
import store from '@/store/store'
import { LOGOUT } from '@/store/action.types'

axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    console.log(error)
    switch (error.response.status) {
      case 401:
        store.dispatch(LOGOUT).then(() => {
          console.log('not authorized')
          window.location.href = '/'
        })
        break
      default:
        console.log('no rule for status ' + error.response.status + ' reject')
        return Promise.reject(error)
    }
  })

const ApiService = {
  init() {
    Vue.use(VueAxios, axios)
    Vue.axios.defaults.baseURL = API_URL
    // Vue.axios.defaults.withCredentials = false
    // Vue.axios.defaults.xsrfCookieName = 'false'
  },

  setHeader() {
    Vue.axios.defaults.headers.common[
      'Authorization'
    ] = `Token ${JwtService.getToken()}`
    // Vue.axios.defaults.headers.common[
    //   'X-CSRF-TOKEN'
    // ] = JwtService.getToken()
  },

  query(resource, params) {
    return Vue.axios.get(resource, params)
    // .catch(error => {
    //   throw new Error(`[RWV] ApiService ${error}`)
    // })
  },

  get(resource, slug = '', extra_route = '', config = {}) {
    const params = [`${resource}`, `${slug}`, `${extra_route}`]
    let url = params.join('/').replace(/\/$/, '')
    // append slash to end to prevent 301 redirect. Possible fix to safari
    url = url[url.length - 1] !== '/' ? url = url.concat('/') : url
    return Vue.axios.get(url, config)
    // .catch(error => {
    //   throw new Error(`[RWV] ApiService ${error}`)
    // })
  },
  update_extra_route(resource, slug, params, extra_route) {
    return Vue.axios.put(`${resource}/${slug}/${extra_route}/`, params)
  },
  post_extra_route(resource, slug, params, extra_route) {
    return Vue.axios.post(`${resource}/${slug}/${extra_route}/`, params)
  },
  post(resource, params, config = {}) {
    return Vue.axios.post(`${resource}/`, params, config)
  },

  update(resource, slug, params) {
    return Vue.axios.put(`${resource}/${slug}/`, params)
  },

  put(resource, params) {
    return Vue.axios.put(`${resource}/`, params)
  },

  delete(resource) {
    return Vue.axios.delete(resource)
    // .catch(error => {
    //   throw new Error(`[RWV] ApiService ${error}`)
    // })
  },
  get_app_version() {
    return Vue.axios.get('get_app_version/')
  },
  download_file(resource, slug = '', extra_route = '', ftype = 'zip') {
    const params = [`${resource}`, `${slug}`, `${extra_route}`]
    let url = params.join('/').replace(/\/$/, '')
    let type = 'application/zip'
    if (ftype === 'png') type = 'image/png'
    if (type === 'pdf') type = 'application/pdf'
    url = url[url.length - 1] !== '/' ? url = url.concat('/') : url
    Vue.axios.get(url, { responseType: 'arraybuffer' })
      .then((response) => {
        const match = response.headers['content-disposition'].match(/filename='(.+?)'/)
        const filename = match ? match.pop() : filename

        const blob = new Blob([response.data], { type: type })
        saveAs(blob, filename)
      })
  }
}

export default ApiService
